import React from 'react';
import { PageVideoBlock } from './page-video-block';

const videoList = [null, 'shJs168i6mo', '4kKkOvvW820', 'd_y_5wb6v7Q', null];

type PageVideoBlockContainerPropsType = {
    videoIndex?: number;
};

const PageVideoBlockContainer = ({ videoIndex }: PageVideoBlockContainerPropsType) => {
    // make sure we always have video
    const videoId = videoIndex ? videoList[videoIndex] : videoList[0];

    return <PageVideoBlock videoId={videoId} />;
};

export { PageVideoBlockContainer };
